import Lottie from "lottie-react";

import loaderAnimation from "@/assets/lw_logo_loader.json";
import { cn } from "@/lib/utils/cn";

const LawWorksLoader = ({
  className,
  logoClassName,
}: {
  className?: string;
  logoClassName?: string;
}) => {
  return (
    <div
      className={cn("flex h-screen items-center justify-center", className)}
      role="status"
    >
      <span className="sr-only">Loading</span>
      <div
        aria-hidden
        className={cn("aspect-square w-[300px] max-w-[90vw]", logoClassName)}
      >
        <Lottie animationData={loaderAnimation} loop className="size-full" />
      </div>
    </div>
  );
};

export default LawWorksLoader;
